function replace(string, map = {}) {
    return Object.keys(map).reduce((acc, key) => {
        return acc.replace(key, map[key]);
    }, string || "");
}

/* global BX */
export function getMessage(msg, map = {}, defaultMsg) {
    return typeof BX != "undefined" ? replace(BX.message(msg), map) : (defaultMsg ?? "");
}